import React from 'react'

function Text() {
    return (
        <>
        <article>
            <h3>Customize Your card</h3>
        </article>

            
        </>
    )
}

export {Text}
